<!--
  Do not remove Transloco directive here: it will make the ionViewDidEnter hook load too soon in sub-components.
-->
<ng-container *transloco="let t">

  <ion-app>
    <ion-router-outlet></ion-router-outlet>
  </ion-app>

</ng-container>
